import { EEditabilityType, ESdChangeReason, IConditionModel, IEditability } from "@kuika/kuika-cl-model";
import _ from "lodash";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../../shared/pure-sd";
import KuikaCollapsePanel from "../../../ui-kit/kuika-collapse-panel/kuika-collapse-panel";
import KuikaSelectbox from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import KuikaSmallText from "../../../ui-kit/typography/SmallText/SmallText";
import KuikaTextMedium from "../../../ui-kit/typography/TextMedium/TextMedium";
import { Comparison } from "./condition";
import PropertyRowIcon from "./property-row-icon";

export interface IEditabilityPanelState {
  isEditabilityPanelActive: boolean;
}

export interface IEditabilityPanelProps {
  onEditabilitySaved: (editability: IEditability, changeReason?: ESdChangeReason | undefined) => void;
  editability: IEditability;
}

class EditabilityPanel extends PureSdComponent<IEditabilityPanelProps & IWithSDProps, IEditabilityPanelState> {
  constructor(props: IEditabilityPanelProps & IWithSDProps) {
    super(props);
    this.state = {
      isEditabilityPanelActive: false
    };
  }

  // There is no fourth state: the model's type is a non-nullable enum whose zero value, Enabled, is
  // also what a generated app assumes when the field is missing. Clearing resets to it rather than
  // writing a null into the tree that code generation reads.
  handleStatusChange = (value: EEditabilityType | null): void => {
    const editability: IEditability = _.cloneDeep(this.props.editability);
    editability.editabilityType = value ?? EEditabilityType.Enabled;

    if (editability.editabilityType !== EEditabilityType.Custom) {
      editability.condition = undefined;
    }

    this.props.onEditabilitySaved(editability);
  };

  handleActionCondition = (condition: IConditionModel) => {
    const editability: IEditability = _.cloneDeep(this.props.editability);
    editability.condition = condition;
    this.props.onEditabilitySaved(editability, ESdChangeReason.UpdateEditability);
  };

  render() {
    return (
      <>
        <KuikaCollapsePanel
          activeKey={this.state.isEditabilityPanelActive ? "editability-panel" : ""}
          onChange={() => {
            this.setState({ isEditabilityPanelActive: !this.state.isEditabilityPanelActive });
          }}
          iconPlacement="right"
          className="kuika-right-panel__collapse kuika-right-panel__collapse-lighter kuika-right-panel__collapse--boxed kuika-right-panel__collapse--editability"
          items={[
            {
              key: "editability-panel",
              label: (
                <>
                  <PropertyRowIcon kind="editability" />
                  <KuikaTextMedium data-onboarding-id="editability-panel-header-title">Editability</KuikaTextMedium>
                </>
              ),
              children: (
                <div className="kuika-right-panel__collapse-body">
                  <div className="kuika-right-panel__col kuika_property-grid-column kuika_select_property">
                    <div className="kuika-right-panel__row">
                      <div className="kuika-right-panel__col">
                        <KuikaSmallText>Will be ...</KuikaSmallText>
                        <KuikaSelectbox
                          allowClear
                          value={this.props.editability.editabilityType}
                          placeholder="Select"
                          onChange={this.handleStatusChange}
                          options={[
                            { value: EEditabilityType.Enabled, label: "Enabled" },
                            { value: EEditabilityType.Disabled, label: "Disabled" },
                            { value: EEditabilityType.Custom, label: "Sometimes Enabled" }
                          ]}
                        />
                      </div>
                    </div>

                    {this.props.editability.editabilityType === EEditabilityType.Custom && (
                      <div className="kuika-right-panel__row">
                        <div className="kuika-right-panel__col">
                          <Comparison
                            condition={this.props.editability.condition}
                            onChange={this.handleActionCondition}
                            conditionType="editability"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )
            }
          ]}
        />
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.UpdateEditability ||
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock ||
      changeReason === ESdChangeReason.ActionParameterFixedValueChanged
    ) {
      return true;
    }
    return false;
  };
}

const editabilityPanel = withSD<IEditabilityPanelProps>(EditabilityPanel);
export { editabilityPanel as EditabilityPanel };
